exports.openKefu=function(){
  window.KF5SupportBoxAPI.ready(function() {
    // 打开组件弹出层
    window.KF5SupportBoxAPI.open(function() {
      // 动画完成后执行的回调函数
      // .........
    })
  })
}



// WEBPACK FOOTER //
// ./src/util/kf.js